(function () {
  var section = document.querySelector('[data-b2b-subnav]');
  if (!section) return;

  var parentLabel = (section.getAttribute('data-b2b-parent-label') || 'For Golf Clubs').trim().toLowerCase();
  var panel = section.querySelector('[data-b2b-mobile-panel]');
  var sectionEl = section.closest('.shopify-section') || section;
  var desktopNav = section.querySelector('.b2b-subnav--desktop');
  var headerSection = document.querySelector('.f-section-header');
  var headerEl = document.querySelector('[data-section-type="header"]');
  var placeholder = null;
  var desktopMq = window.matchMedia('(min-width: 1024px)');
  var pinnedState = false;

  function normalize(text) {
    return (text || '').replace(/\s+/g, ' ').trim().toLowerCase();
  }

  function markMainNavActive() {
    if (section.getAttribute('data-b2b-on-hub') !== 'true') return;

    document.querySelectorAll('.f-site-nav__item, .f-mobile-nav__item').forEach(function (item) {
      var link = item.querySelector(':scope > .f-site-nav__link, :scope > .f-mobile-nav__link, :scope > a.f-mobile-nav__link, :scope > span.f-mobile-nav__link');
      if (!link) return;
      if (normalize(link.textContent) === parentLabel) {
        item.classList.add(item.classList.contains('f-site-nav__item') ? 'f-site-nav__item--b2b-active' : 'f-mobile-nav__item--b2b-active');
      }
    });
  }

  function wireMobileParent() {
    if (!panel) return;

    var mobileNav = document.querySelector('#Mobile-Nav');
    if (!mobileNav) return;

    var list = mobileNav.querySelector('.f-mobile-nav__inner > ul');
    if (!list) return;

    var items = list.querySelectorAll(':scope > .f-mobile-nav__item');
    var parentItem = null;

    items.forEach(function (item) {
      var link = item.querySelector(':scope > .f-mobile-nav__link, :scope > a.f-mobile-nav__link, :scope > span.f-mobile-nav__link');
      if (!link || normalize(link.textContent) !== parentLabel) return;
      parentItem = item;
    });

    if (!parentItem) return;

    var link = parentItem.querySelector(':scope > .f-mobile-nav__link, :scope > a.f-mobile-nav__link, :scope > span.f-mobile-nav__link');
    parentItem.classList.add('f-mobile-nav__item--b2b');
    parentItem.setAttribute('data-collapsible-parent', '');

    var existingTab = parentItem.querySelector(':scope > collapsible-tab');
    if (existingTab) existingTab.remove();

    var mount = mobileNav.querySelector('[data-b2b-mobile-panel-mounted]');
    if (!mount) {
      mount = panel.cloneNode(true);
      mount.removeAttribute('hidden');
      mount.classList.remove('is-visible');
      mount.setAttribute('data-b2b-mobile-panel-mounted', '');
      var inner = mobileNav.querySelector('.f-mobile-nav__inner');
      if (inner) inner.insertBefore(mount, inner.firstChild);
    }

    function openClubsNav(event) {
      if (event) {
        event.preventDefault();
        event.stopPropagation();
      }
      mobileNav.classList.add('is-b2b-clubs-nav');
      mount.classList.add('is-visible');
    }

    function closeClubsNav() {
      mobileNav.classList.remove('is-b2b-clubs-nav');
      mount.classList.remove('is-visible');
    }

    if (link) {
      if (link.tagName === 'A') link.setAttribute('href', '#');
      link.addEventListener('click', openClubsNav);
    }

    var drawer = mobileNav.closest('drawer-component') || document.querySelector('.f-drawer-mobile-nav');
    if (drawer && !drawer.dataset.b2bClubsBound) {
      drawer.dataset.b2bClubsBound = '1';
      drawer.addEventListener('close', closeClubsNav);
    }

    var closeBtn = document.getElementById('DrawerClose-Mobile-Nav');
    if (closeBtn && !closeBtn.dataset.b2bClubsBound) {
      closeBtn.dataset.b2bClubsBound = '1';
      closeBtn.addEventListener('click', closeClubsNav);
    }
  }

  function measureHeaderHeight() {
    var el = headerEl || (headerSection && headerSection.querySelector('.header'));
    if (!el) return 0;
    return Math.ceil(el.getBoundingClientRect().height);
  }

  function ensurePlaceholder() {
    if (placeholder || !sectionEl.parentNode) return;
    placeholder = document.createElement('div');
    placeholder.className = 'b2b-subnav-placeholder';
    placeholder.setAttribute('aria-hidden', 'true');
    placeholder.style.height = sectionEl.offsetHeight + 'px';
    sectionEl.parentNode.insertBefore(placeholder, sectionEl);
  }

  function clearPlaceholder() {
    if (!placeholder) return;
    placeholder.remove();
    placeholder = null;
  }

  function syncStickySubnav() {
    var onHub = section.getAttribute('data-b2b-on-hub') === 'true';
    var pinned = document.body.classList.contains('header-pinned');
    var scrolled = !!(headerSection && headerSection.classList.contains('header-scrolled'));

    if (!onHub || !desktopNav || !desktopMq.matches) {
      sectionEl.classList.remove('is-b2b-pinned', 'is-b2b-hidden', 'no-transition');
      clearPlaceholder();
      pinnedState = false;
      return;
    }

    sectionEl.style.setProperty('--b2b-subnav-top', measureHeaderHeight() + 'px');

    if (!scrolled) {
      sectionEl.classList.remove('is-b2b-pinned', 'is-b2b-hidden', 'no-transition');
      clearPlaceholder();
      pinnedState = false;
      return;
    }

    var becomingPinned = !pinnedState;
    if (becomingPinned) {
      ensurePlaceholder();
      if (placeholder) placeholder.style.height = sectionEl.offsetHeight + 'px';
      sectionEl.classList.add('no-transition');
      sectionEl.classList.add('is-b2b-pinned', 'is-b2b-hidden');
      sectionEl.offsetHeight;
      sectionEl.classList.remove('no-transition');
      pinnedState = true;
    }

    sectionEl.classList.toggle('is-b2b-hidden', !pinned);
  }

  function initStickySubnav() {
    if (section.getAttribute('data-b2b-on-hub') !== 'true' || !desktopNav) return;

    var observer = new MutationObserver(function () {
      requestAnimationFrame(syncStickySubnav);
    });
    observer.observe(document.body, { attributes: true, attributeFilter: ['class'] });
    if (headerSection) {
      observer.observe(headerSection, { attributes: true, attributeFilter: ['class'] });
    }

    desktopMq.addEventListener('change', syncStickySubnav);
    window.addEventListener('resize', function () {
      if (sectionEl.classList.contains('is-b2b-pinned')) {
        sectionEl.style.setProperty('--b2b-subnav-top', measureHeaderHeight() + 'px');
      }
      syncStickySubnav();
    });

    syncStickySubnav();
  }

  markMainNavActive();
  wireMobileParent();
  initStickySubnav();
})();
